import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../store';

export function GuestIdleView() {
  const { t } = useTranslation();
  const setAuthView = useAuth(s => s.setAuthView);

  return (
    <>
      <div className="flex items-center justify-between mb-2">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-500">
          👤 {t('storeSettings.guest')}
        </span>
        <button
          onClick={() => setAuthView('login')}
          className="text-sm text-blue-600 hover:underline"
        >
          {t('storeSettings.login')}
        </button>
      </div>
      <p className="text-xs text-gray-400">{t('storeSettings.guestHint')}</p>
    </>
  );
}
